import CreateOfferComponent from "@components/CreateOfferComponent/CreateOfferComponent";
import CustomSelect from "@components/CustomSelect/CustomSelect";
import { CreateModalContext } from "layouts/appLayout/layout";
import React, { useContext } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";

const QuoteTable = ({
  lines,
  offersData,
  handleLineChange,
  handleRemoveLine,
  handleAddLine,
  handleDragEnd,
  isUpdate,
  initialValues,
  handleItemChange,
}) => {
  const { t } = useTranslation();
  const { toggleCreateModal } = useContext(CreateModalContext);

  const handleAddOffer = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateOfferComponent onClose={() => toggleCreateModal(<></>)} />,
      t("offer.create_form.title")
    );
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="invoice-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "300px" }}>{t("invoice.product_service")}</th>
            <th style={{ width: "300px" }}>{t("invoice.description")}</th>
            <th>{t("invoice.quantity")}</th>
            <th style={{ width: "200px" }}>{t("invoice.price_ht")}</th>
            <th>{t("invoice.reduction")}</th>
            <th>{t("invoice.total_ht")}</th>
            <th>{t("invoice.tva_percentage")}</th>

            <th></th>
          </tr>
        </thead>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="invoice-lines">
            {(provided) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {lines?.map((line, index) => {
                  return (
                    <Draggable
                      key={index}
                      draggableId={`line-${index}`}
                      index={index}>
                      {(provided) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            backgroundColor: "#fff",
                            borderBottom: "1px solid #ddd",
                          }}>
                          {/* Sélection de l'offre */}
                          <td style={{ width: "300px" }}>
                            <div className="input-with-button">
                  
                              <CustomSelect
                                style={{ minWidth: 200 }}
                                selectWhat={t("invoice.select_offer")}
                                value={line?.idOffer}
                                onChange={(e) => {
                                  const selectedId = e.target.value;
                                  const selectedOffer = offersData?.find(
                                    (offer) => offer._id === selectedId
                                  );
                                  handleLineChange(
                                    index,
                                    "idOffer",
                                    selectedId
                                  );
                                  if (selectedOffer) {
                                    handleLineChange(index, {
                                      description:
                                        selectedOffer.description || "",
                                      price: selectedOffer.price || 0,
                                    });
                                    handleItemChange(index, selectedOffer);
                                  }
                                }}
                                options={offersData}
                                isOffer={true}
                                allowCustomValue={false}
                              />
                              <button
                                type="button"
                                className="add-button"
                                onClick={handleAddOffer}
                                title={t("invoice.add_offer")}>
                                +
                              </button>
                            </div>
                          </td>

                          {/* Description */}
                          <td style={{ width: "300px" }}>
                            <textarea
                              value={line.description || ""}
                              onChange={(e) =>
                                handleLineChange(
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                              className="table-input "
                              rows={2}
                              style={{ resize: "vertical", width: "100%" }}
                            />
                          </td>

                          {/* Quantité */}
                          <td>
                            <input
                              type="number"
                              value={line.quantity || ""}
                              onChange={(e) =>
                                handleLineChange(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                              className="table-input "
                              min={0}
                            />
                          </td>

                          {/* Prix unitaire HT */}
                          <td style={{ width: "200px" }}>
                            <input
                              type="number"
                              value={line.price || ""}
                              onChange={(e) =>
                                handleLineChange(index, "price", e.target.value)
                              }
                              className="table-input"
                              min={0}
                            />
                          </td>

                          {/* Remise */}
                          <td>
                            <input
                              type="number"
                              value={line?.reduction || ""}
                              onChange={(e) =>
                                handleLineChange(
                                  index,
                                  "reduction",
                                  e.target.value
                                )
                              }
                              className="table-input "
                              placeholder="%"
                              min={0}
                              max={100}
                              style={{ width: "60px" }}
                            />
                          </td>

                          {/* Total HT */}
                          <td>
                            {line.quantity && line.price
                              ? (
                                  line.quantity *
                                  line.price *
                                  (1 - (line.reduction || 0) / 100)
                                ).toFixed(2) + " €"
                              : "0.00 €"}
                          </td>

                          {/* TVA */}
                          <td>
                            <input
                              type="number"
                              value={line.tva || ""}
                              onChange={(e) =>
                                handleLineChange(index, "tva", e.target.value)
                              }
                              className="table-input "
                              placeholder="20%"
                              min={0}
                              max={100}
                              style={{ width: "60px" }}
                            />
                          </td>

                          {/* Supprimer ligne */}
                          <td>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => handleRemoveLine(index)}>
                              ×
                            </button>
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      </table>
    </div>
  );
};

export default QuoteTable;
